import { SampleDataOverlay } from "./DiscoveryHubSampleState";
import LevelTrendChart from "./LevelTrendChart";
import {
  S7_QUADRANT,
  S7_QUADRANT_H,
  S7_QUADRANT_PERIOD,
  S7_QUADRANT_SUB,
} from "../../Utils/Helper/discoveryHubUi";

type TrendPoint = {
  period: string;
  composite: number | null;
};

const SAMPLE_TREND: TrendPoint[] = [
  { period: "2024-Q3", composite: 2.9 },
  { period: "2024-Q4", composite: 3.2 },
  { period: "2025-Q1", composite: 3.0 },
  { period: "2025-Q2", composite: 3.5 },
  { period: "2025-Q3", composite: 3.8 },
  { period: "2025-Q4", composite: 4.1 },
];

const LINE_COLOR = "#9333EA";

type Props = {
  points: TrendPoint[];
};

const PortfolioTrendChart = ({ points }: Props) => {
  const realCount = points.filter(p => p.composite != null).length;
  const isSample = realCount < 2;
  const displayPoints = isSample ? SAMPLE_TREND : points;

  const chartData = displayPoints.slice(-6).map(p => ({
    name: p.period.includes("-") ? p.period.split("-")[1] : p.period,
    value: p.composite,
  }));

  return (
    <div className={S7_QUADRANT}>
      <div className={S7_QUADRANT_H}>
        Portfolio Trend
        <span className={S7_QUADRANT_PERIOD}>5 quarters</span>
      </div>

      <div className="px-4 pb-4 pt-3">
        <div className={S7_QUADRANT_SUB}>
          Sponsor composite across recent quarters
        </div>

        <SampleDataOverlay
          active={isSample}
          compact
          message="Preview of portfolio trend — real data appears once poll results are available."
        >
          <LevelTrendChart
            data={chartData}
            color={LINE_COLOR}
            domain={[1, 5]}
            ticks={[1, 2, 3, 4, 5]}
            numericYAxis
            height={320}
            tickFontSize={14}
            chartMargin={{ top: 8, right: 8, bottom: 8, left: 4 }}
            xAxisHeight={28}
          />
        </SampleDataOverlay>
      </div>
    </div>
  );
};

export default PortfolioTrendChart;
